<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="row mt-5">
          <div class="col-md-3">
            <div class="dropdown quickFilters">
              <div class="small label-field">{{ app.text.RM.selectType }}</div>
              <button
                class="btn dropdown-toggle btn-group-rm text-center"
                type="button"
                id="quickFilters"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >
                <span> {{ getTextDisplay(app.RMSearch.selectedType) }} </span>
              </button>
              <div class="icon">
                @switch (app.RMSearch.selectedType) {
                  @case ('assembly') {
                    <span>
                      <i class="fas fa-chart-pie-alt"></i>
                    </span>
                  }
                  @case ('part') {
                    <span>
                      <i class="far fa-chart-pie-alt"></i>
                    </span>
                  }
                  @case ('manufacturer') {
                    <span>
                      <i class="far fa-chart-pie"></i>
                    </span>
                  }
                }
              </div>
              <div
                id="filterTypeDropdown"
                class="dropdown-menu"
                aria-labelledby="filterType"
                role="menu"
                >
                @for (type of types; track type) {
                  <a
                    class="dropdown-item pointer"
                    (click)="setType(type)"
                    >
                    {{ getTextDisplay(type) }}</a
                    >
                  }
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="dropdown quickFilters">
                <div class="small label-field">
                  {{ app.text.RM.selectProperty }}
                </div>
                <button
                  class="btn dropdown-toggle btn-group-rm text-center"
                  type="button"
                  id="quickFilters"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >
                  <span>
                    {{ app.RMSearch.getFilterLabel(app.RMSearch.filterMode) }}
                  </span>
                </button>
                <div class="icon">
                  <i class="fas fa-keyboard"></i>
                </div>
                <div
                  id="filterTypeDropdown"
                  class="dropdown-menu"
                  aria-labelledby="filterType"
                  role="menu"
                  >
                  @for (prop of properties; track prop) {
                    <a
                      class="dropdown-item pointer"
                      (click)="app.RMSearch.setFilterMode(prop)"
                      >
                      {{ app.RMSearch.getFilterLabel(prop) }}</a
                      >
                    }
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="small label-field">
                  {{ app.text.RM.enter }}
                  {{ app.RMSearch.getFilterLabel(app.RMSearch.filterMode) }}
                </div>
                <div class="btn-group-rm">
                  <app-field
                    [model]="model"
                    [field]="app.fieldId.RM.searchField"
                    [showLabel]="false"
                    [showMandatory]="true"
                    >
                  </app-field>
                </div>

                <div
                  id="filterTypeDropdown"
                  class="dropdown-menu"
                  aria-labelledby="filterType"
                  role="menu"
                  >
                  @if (properties.length > 0) {
                    <span>
                      @for (prop of properties; track prop) {
                        <a
                          class="dropdown-item pointer"
                          (click)="app.RMSearch.setFilterMode(prop)"
                          >
                          {{ app.RMSearch.getFilterLabel(prop) }}</a
                          >
                        }
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          @if (app.RMSearch.displayResults) {
            <div
              class="col-md-12 no-padding tableFixHead"
              >
              <table class="table table-striped">
                <thead>
                  <tr>
                    @for (column of app.RMSearch.columns; track column) {
                      <th class="p-1">
                        <div>
                          <span
                  (click)="
                    app.table.toggleSortDirection(column);
                    app.table.sort(app.RMSearch.RMDocs)
                  "
                            >{{ app.field.handleSpecialLogicLabels(column) }}</span
                            >&nbsp;
                            @if (column === app.table.sortField) {
                              <span>
                                @if (app.table.sortDirection === 1) {
                                  <i
                                    class="fa fa-chevron-up"
                                  ></i>
                                }
                                @if (app.table.sortDirection === -1) {
                                  <i
                                    class="fa fa-chevron-down"
                                  ></i>
                                }
                              </span>
                            }
                          </div>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (doc of app.RMSearch.RMDocs; track doc) {
                      <tr class="rm-table-row">
                        @for (column of app.RMSearch.columns; track column) {
                          <td
                            class="p-1"
              (click)="
                app.RM.navigateRMComponents(
                  app.RMSearch.selectedType,
                  true,
                  doc._id
                )
              "
                            >
                            <div>
                              @switch (app.table.getColumnTypeDisplay(column.split('.')[1])) {
                                @case ('badge') {
                                  <span>
                                    <span
                                      class="col-6 btn badge"
                    [ngStyle]="
                      app.field.getColor(column, doc[column.split('.')[1]])
                    "
                                      >{{
                                      app.field.getOptionText(column, doc[column.split(".")[1]])
                                      }}</span
                                      >
                                    </span>
                                  }
                                  @case ('optionText') {
                                    <span>
                                      {{
                                      app.field.getOptionText(column, doc[column.split(".")[1]])
                                      }}
                                    </span>
                                  }
                                  @default {
                                    <div class="rm-cell">
                                      {{ doc[column.split(".")[1]] }}
                                    </div>
                                  }
                                }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                      <tr>
                        @if (app.RMSearch.RMDocs.length === 0) {
                          <td
                            colspan="99"
                            class="text-center"
                            >
                            {{ app.text.app.noResults }}
                          </td>
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </div>
